import React, { useEffect } from "react";
import InvoiceField from "../component/InvoiceFiled";

const HotelForm = ({ data = {}, onUpdate = () => {} }) => {

  // Ensure at least one item row
  useEffect(() => {
    if (!data?.items || data.items.length === 0) {
      onUpdate("items", [{ desc: "", qty: "", rate: "", amount: "0.00" }]);
    }
  }, []);

  const items = data?.items || [];

  const handleItemChange = (index, key, value) => {
    const updatedItems = [...items];
    updatedItems[index] = { ...updatedItems[index], [key]: value };

    const qty = parseFloat(updatedItems[index].qty || 0);
    const rate = parseFloat(updatedItems[index].rate || 0);
    updatedItems[index].amount = (qty * rate).toFixed(2);

    onUpdate("items", updatedItems);
  };

  const addItem = () => {
    onUpdate("items", [...items, { desc: "", qty: "", rate: "", amount: "0.00" }]);
  };

  const removeItem = (index) => {
    const updatedItems = items.filter((_, i) => i !== index);
    onUpdate("items", updatedItems.length ? updatedItems : [{ desc: "", qty: "", rate: "", amount: "0.00" }]);
  };

  const handleSave = () => {
    localStorage.setItem("hotelInvoiceData", JSON.stringify(data));
    alert("Invoice Saved Successfully");
  };

  return (
    <div className="space-y-8">

      <h3 className="font-bold text-lg text-[#F3A536] border-b pb-2 uppercase tracking-wide">
        Hotel Invoice Form
      </h3>

      {/* HOTEL + INVOICE DETAILS */}
      <div className="border rounded p-4">
        <h4 className="font-semibold text-sm text-gray-500 mb-4 uppercase">Hotel & Invoice Info</h4>
        <div className="grid grid-cols-2 gap-4">
          <InvoiceField
            label="Hotel Name"
            value={data?.hotelName || ""}
            onChange={(v) => onUpdate("hotelName", v)}
          />
          <InvoiceField
            label="Invoice Number"
            value={data?.invoiceNumber || ""}
            onChange={(v) => onUpdate("invoiceNumber", v)}
          />
          <InvoiceField
            label="Date Issued"
            type="date"
            value={data?.dateIssued || ""}
            onChange={(v) => onUpdate("dateIssued", v)}
          />
          <InvoiceField
            label="Room Number"
            value={data?.roomNumber || ""}
            onChange={(v) => onUpdate("roomNumber", v)}
          />
        </div>
      </div>

      {/* GUEST DETAILS */}
      <div className="border rounded p-4">
        <h4 className="font-semibold text-sm text-gray-500 mb-4 uppercase">Guest Information</h4>
        <div className="grid grid-cols-2 gap-4">
          <InvoiceField
            label="Guest Name"
            value={data?.clientName || ""}
            onChange={(v) => onUpdate("clientName", v)}
          />
          <InvoiceField
            label="Phone Number"
            value={data?.clientPhone || ""}
            onChange={(v) => onUpdate("clientPhone", v)}
          />
        </div>
        <div className="mt-4">
          <InvoiceField
            label="Address"
            type="description"
            rows="2"
            value={data?.clientAddress || ""}
            onChange={(v) => onUpdate("clientAddress", v)}
          />
        </div>
      </div>

      {/* CHECK-IN / CHECK-OUT */}
      <div className="border rounded p-4">
        <h4 className="font-semibold text-sm text-gray-500 mb-4 uppercase">Stay Details</h4>
        <div className="grid grid-cols-2 gap-4">
          <InvoiceField
            label="Check-In Date"
            type="date"
            value={data?.checkIn || ""}
            onChange={(v) => onUpdate("checkIn", v)}
          />
          <InvoiceField
            label="Check-Out Date"
            type="date"
            value={data?.checkOut || ""}
            onChange={(v) => onUpdate("checkOut", v)}
          />
        </div>
      </div>

      {/* BILLING ITEMS */}
      <div className="border rounded p-4">
        <h4 className="font-semibold text-sm text-gray-500 mb-4 uppercase">Billing Items</h4>

        {/* Header */}
        <div className="grid grid-cols-5 gap-2 text-xs font-semibold text-gray-500 mb-2">
          <div>Description</div>
          <div className="text-center">Qty</div>
          <div className="text-center">Rate (₹)</div>
          <div className="text-right">Amount (₹)</div>
          <div className="text-center">Action</div>
        </div>

        {/* Rows */}
        {items.map((item, idx) => (
          <div key={idx} className="grid grid-cols-5 gap-2 mb-2 items-center">
            <input
              type="text"
              value={item.desc}
              onChange={(e) => handleItemChange(idx, "desc", e.target.value)}
              className="border px-2 py-1 rounded text-sm"
              placeholder="Room Charge / Food / Service"
            />

            <input
              type="number"
              value={item.qty}
              onChange={(e) => handleItemChange(idx, "qty", e.target.value)}
              className="border px-2 py-1 rounded text-sm text-center"
              placeholder="0"
            />

            <input
              type="number"
              value={item.rate}
              onChange={(e) => handleItemChange(idx, "rate", e.target.value)}
              className="border px-2 py-1 rounded text-sm text-center"
              placeholder="0.00"
            />

            <input
              type="text"
              value={item.amount}
              readOnly
              className="border px-2 py-1 rounded text-sm text-right bg-gray-100"
            />

            <button
              onClick={() => removeItem(idx)}
              className="px-2 py-1 text-xs bg-red-100 text-red-600 rounded hover:bg-red-200"
            >
              Remove
            </button>
          </div>
        ))}

        {/* Add Button */}
        <div className="flex justify-end mt-3">
          <button
            onClick={addItem}
            className="px-4 py-1.5 text-sm font-semibold border border-[#F3A536] text-[#F3A536] rounded hover:bg-[#F3A536] hover:text-white transition"
          >
            + Add Item
          </button>
        </div>
      </div>

      {/* CHARGES */}
      <div className="border rounded p-4">
        <h4 className="font-semibold text-sm text-gray-500 mb-4 uppercase">Extra Charges</h4>
        <div className="grid grid-cols-2 gap-4">
          <InvoiceField
            label="Service Charge (₹)"
            type="number"
            value={data?.serviceCharge || ""}
            onChange={(v) => onUpdate("serviceCharge", v)}
          />
          <InvoiceField
            label="Tax (₹)"
            type="number"
            value={data?.taxes || ""}
            onChange={(v) => onUpdate("taxes", v)}
          />
        </div>
      </div>

      {/* SAVE */}
      <div className="flex justify-end">
        <button
          onClick={handleSave}
          className="px-6 py-2 bg-[#F3A536] text-white font-semibold rounded hover:bg-[#d9922e]"
        >
          Save Invoice
        </button>
      </div>

    </div>
  );
};

export default HotelForm;
